import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  formatDateTime,
  formatPercentage,
  keepParams,
} from '@homamo/meadow-utils';

import Button from '../../common/Button';
import Table, { TableButtonGroup } from '../../common/Table';
import DeleteLender from '../DeleteLender';

const LendersTableComponent = ({
  data,
  isLoading,
  pageCount,
  fetchData,
  totalCount,
  initialSortBy,
  filterOptions,
  onLenderDeleted,
  isCompact,
}) => {
  // const history = useHistory();

  const columns = useMemo(
    /* eslint-disable react/prop-types */
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        sortType: 'basic',
        id: 'name',
        minWidth: 200,
      },
      {
        Header: 'SVR',
        accessor: ({ svr }) => formatPercentage(svr, 2),
        sortType: 'basic',
        id: 'svr',
        minWidth: 180,
      },
      {
        Header: 'Created',
        accessor: ({ createdAt }) => formatDateTime(createdAt),
        sortType: 'datetime',
        id: 'createdAt',
        width: 150,
      },
      {
        Header: 'Updated',
        accessor: ({ updatedAt }) => formatDateTime(updatedAt),
        sortType: 'datetime',
        id: 'updatedAt',
        width: 150,
      },
      {
        Header: 'Actions',
        accessor: '_id',
        disableSortBy: true,
        width: 200,
        sticky: 'right',
        Cell: ({ cell: { value }, row: { original } }) => (
          <TableButtonGroup>
            <Button
              label="View"
              size="s"
              linkTo={keepParams(`/admin/lender/${value}`)}
            />
            <Button
              label="Edit"
              size="s"
              linkTo={keepParams(`/admin/lender/${value}/edit`)}
            />
            <DeleteLender
              id={value}
              lender={original}
              onLenderDeleted={onLenderDeleted}
            />
          </TableButtonGroup>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [], // Second array to allow memo
    /* eslint-enable react/prop-types */
  );

  return (
    <>
      <Table
        name="lenders"
        columns={columns}
        data={data}
        fetchData={fetchData}
        isLoading={isLoading}
        pageCount={pageCount}
        totalCount={totalCount}
        blankState="No lenders found"
        initialSortBy={initialSortBy}
        searchPlaceholder="Search for a lender name"
        filterOptions={filterOptions}
        isCompact={isCompact}
        defaultPageSize={20}
        enableSearch
      />
    </>
  );
};

LendersTableComponent.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
    }),
  ),
  onLenderDeleted: PropTypes.func,
  isLoading: PropTypes.bool,
  pageCount: PropTypes.number,
  totalCount: PropTypes.number,
  fetchData: PropTypes.func.isRequired,
  initialSortBy: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      desc: PropTypes.bool,
    }),
  ).isRequired,
  isCompact: PropTypes.bool,
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

LendersTableComponent.defaultProps = {
  data: [],
  onLenderDeleted: undefined,
  isLoading: false,
  pageCount: 0,
  totalCount: 0,
  isCompact: false,
  filterOptions: [],
};

export default LendersTableComponent;
